var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrolltop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1f2f60;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M527.51,79.92C122.4,105.77-40.75,605.93,275.12,859.56c246.45,197.9,620.66,68.74,695.76-236.31,68.97-280.17-152.74-561.87-443.37-543.33ZM693.49,529.28c-29.38-4.7-75.53-71.85-101.89-89.66v261.22c0,.99-2.81,12.92-3.45,14.99-9.69,31.6-52.62,40.71-74.39,15.72-1.91-2.19-10.26-17.1-10.26-18.42v-275.55l-83.92,83.05c-41.4,30.44-91.52-19.57-62.62-60.57l155.81-155.6c27.4-18.47,53.99-12.11,77.86,8.09,48.97,41.44,92.66,98.55,141.33,141.39,30.33,31.26,4.33,82.18-38.47,75.34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrolltop);
export default __webpack_public_path__ + "static/media/Scrolltop.30f012eabd97310865011812796ef1cc.svg";
export { ForwardRef as ReactComponent };